<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head d-flex flex-wrap align-center justify-space-between">
      <div>
        <h1 class="page-head__title">Members</h1>
        <p class="page-head__sub">All registered credit union members.</p>
      </div>
      <v-btn
        :to="{ name: 'admin.customers.new' }"
        color="primary"
        depressed
        class="text-none add-btn"
      >
        <v-icon small left>mdi-plus</v-icon>
        Add New Member
      </v-btn>
    </div>

    <div class="toolbar d-flex align-center mb-4">
      <v-text-field
        outlined
        dense
        rounded
        hide-details
        prepend-inner-icon="mdi-magnify"
        placeholder="Search members by first or last name…"
        v-model="search"
        color="primary"
        class="toolbar__search"
      />
    </div>

    <v-data-table
      :headers="headers"
      :items="allMembers"
      :loading="pageLoading"
      :server-items-length="paginate.total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :footer-props="{ itemsPerPageOptions: [30, 40, 50] }"
    >
      <template #item.avatar="{ item }">
        <v-avatar size="36" class="cell-avatar">
          <span>{{
            item.firstName ? item.firstName : item.lastName | firstLetterFunction
          }}</span>
        </v-avatar>
      </template>
      <template #item.name="{ item }">
        <span class="cell-strong text-capitalize"
          >{{ item.firstName }} {{ item.lastName }}</span
        >
      </template>
      <template #item.code="{ item }">
        <span class="tabular">{{ item.code }}</span>
      </template>
      <template #item.address="{ item }">
        <span v-if="item.address1" class="text-capitalize">{{
          item.address1
        }}</span>
        <span v-else class="text-muted">No address available</span>
      </template>
      <template #item.phoneNo="{ item }">
        <span class="tabular">{{
          item.phoneNo ? item.phoneNo : item.mobileAlert
        }}</span>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{
                name: 'admin.customers.new',
                query: { id: item._id, action: 'edit' }
              }"
              v-on="on"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Edit member details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :loading="isLoading"
              @click="$store.dispatch('members/delete', item._id)"
              icon
              small
              class="cell-action cell-action--danger"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Delete member details</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
export default {
  name: "AllStaffs",
  data() {
    return {
      options: {},
      search: "",
      searchTerm: null
    };
  },
  components: {
    SnackBar: loadComponent(`component/SnackBar`)
  },

  computed: {
    ...mapGetters({
      allMembers: "members/getAllMembers",
      pageLoading: "getIsPageLoading",
      isLoading: "getIsLoading",
      paginate: "members/getPagination"
    }),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        accountNumber: this.accountNumber
      };
    },
    staffList() {
      return this.allStaff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        {
          text: "",
          value: "avatar",
          filterable: false,
          sortable: false
        },
        {
          text: "Full Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Account Number",
          value: "code",
          filterable: false,
          sortable: false
        },
        { text: "Phone", value: "phoneNo", filterable: false, sortable: false },
        {
          text: "Address",
          value: "address",
          filterable: false,
          sortable: false
        },

        {
          text: "Actions",
          value: "actions"
        }
      ];
    }
  },
  filters: {
    status(value) {
      return !value ? "Active" : "Inactive";
    },
    firstLetterFunction(value) {
      return value.charAt(0).toUpperCase();
    }
  },
  mixins: [SnackBarMixins],
  watch: {
    search: debounce(function(value) {
      if (value === "") {
        this.searchTerm = null;
        this.$store.dispatch(
          "members/list",
          `?page=1&size=30${
            this.activeAccountType ? "&accType=" + this.activeAccountType : ""
          }`
        );
        return;
      }
      this.searchTerm = value;
      const query = `?searchTerm=${value}&page=1&size=30${
        this.activeAccountType ? "&accType=" + this.activeAccountType : ""
      }`;
      this.$store.dispatch("members/searchList", query);
    }, 500),
    options: {
      handler(value) {
        const { itemsPerPage, page } = value;
        const query = `?page=${page}&size=${itemsPerPage}${
          this.activeAccountType ? "&accType=" + this.activeAccountType : ""
        }${this.searchTerm ? "&searchTerm=" + this.searchTerm : ""}`;
        if (this.searchTerm) {
          this.$store.dispatch("members/searchList", query);
        } else {
          this.$store.dispatch("members/list", query);
        }
      },
      deep: true
    },
    activeAccountType(value) {
      if (value) {
        const query = `?page=1&size=30&accType=${value}`;
        this.$store.dispatch("members/list", query);
        return;
      }
      const query = `?page=1&size=30`;
      this.$store.dispatch("members/list", query);
    }
  },
  methods: {},
  created() {
    const query = `?page=1&size=30`;
    this.$store.dispatch("members/list", query);
  }
};
</script>

<style scoped>
.toolbar__search {
  max-width: 460px;
  width: 100%;
}
.add-btn {
  border-radius: var(--radius) !important;
  height: 40px !important;
  font-weight: 600;
}
.cell-avatar {
  background: var(--signal-soft);
  color: var(--signal);
  font-size: 13px;
  font-weight: 600;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.text-muted {
  color: var(--muted-foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
  margin: 0 2px;
}
.cell-action--danger:hover {
  color: var(--status-failed) !important;
}
</style>
